import { ErrorBoundary } from '@sentry/react';
import { FC, Suspense } from 'react';

import { SettingsPageFrame } from '@eluve/blocks';
import { LoadingIndicator } from '@eluve/components';

import { UsersList } from './UsersList';

export const UsersPage: FC<{}> = () => {
  return (
    <SettingsPageFrame size="wide" title="Members">
      <ErrorBoundary fallback={<div>There was an error</div>}>
        <Suspense fallback={<LoadingIndicator size="xl" />}>
          <UsersList />
        </Suspense>
      </ErrorBoundary>
    </SettingsPageFrame>
  );
};
